import React from 'react';
import './CompoundIconBase.css';
export default function CompoundIconBase(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 16 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 16 : _ref$height,
    children = _ref.children,
    modifier = _ref.modifier;
  return /*#__PURE__*/React.createElement("span", {
    className: "_dm-compound-icon ".concat(modifier ? "_dm-compound-icon--".concat(modifier) : ''),
    style: {
      width: width,
      height: height
    }
  }, children);
}